"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomaticRenewalCancellationReasonWidget = void 0;
var React = require("react");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var operators_1 = require("rxjs/operators");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var react_select_1 = require("react-select");
var ExtendedFalconDynamicOptimizedMenuList_1 = require("../../../components/ExtendedFalconDynamicOptimizedMenuList");
var FalconOptimizedOption_1 = require("../../../components/FalconOptimizedOption");
var Types_1 = require("@athena-portal/plugin-journey/dist/Types");
var AutomaticRenewalCancellationReasonWidget = exports.AutomaticRenewalCancellationReasonWidget = /** @class */ (function (_super) {
    __extends(AutomaticRenewalCancellationReasonWidget, _super);
    function AutomaticRenewalCancellationReasonWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBetterPremiumValue = function (event) {
            var _a;
            var betterPremiumValue = event.target.value;
            _this.setState({ betterPremiumValueAnnualMotor: betterPremiumValue });
            var customerCancellationReason = (_a = _this.state.cancellationReason) !== null && _a !== void 0 ? _a : {};
            customerCancellationReason.betterPremiumValue = betterPremiumValue;
            _this.setState({ cancellationReason: customerCancellationReason, cancellationReasonSelected: true });
            _this.props.onStateChange("cancellationReasonInfo", customerCancellationReason);
        };
        _this.handleCancellationReason = function (event) {
            var _a;
            var state = event.target.value;
            var cancellationReasonState = state;
            var customerCancellationReason = (_a = _this.state.cancellationReason) !== null && _a !== void 0 ? _a : {};
            _this.setState({ cancellationReasonAnnualMotor: cancellationReasonState, cancellationReasonSelected: true });
            customerCancellationReason.cancellationReasonCode = event.target.name.replace("_annualMotor", "");
            customerCancellationReason.details = "";
            _this.setState({ cancellationReason: customerCancellationReason, cancellationReasonSelected: true });
            _this.props.onStateChange("cancellationReasonInfo", customerCancellationReason);
        };
        _this.handleCancellationReasonDescription = function (event, productCode, product) {
            var _a;
            var state = event.target.value;
            var cancellationReasonDescription = state;
            _this.setState({ cancellationReasonDescriptionAnnualMotor: cancellationReasonDescription });
            var customerCancellationReason = (_a = _this.state.cancellationReason) !== null && _a !== void 0 ? _a : {};
            customerCancellationReason.cancellationReasonCode = productCode;
            customerCancellationReason.details = cancellationReasonDescription;
            _this.setState({ cancellationReason: customerCancellationReason, cancellationReasonSelected: true });
            _this.props.onStateChange("cancellationReasonInfo", customerCancellationReason);
        };
        _this.incrementLoadingQueueSize = function (callback) {
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize + 1
            }); }, callback);
        };
        _this.decrementLoadingQueueSize = function (callback) {
            if (_this.state.loadingQueueSize === 0) {
                return;
            }
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize - 1
            }); }, callback);
        };
        _this.state = {
            betterPremiumInsurerIdAnnualMotor: -1,
            betterPremiumValueAnnualMotor: -1,
            cancellationReasonAnnualMotor: "",
            cancellationReasonDescriptionAnnualMotor: "",
            cancellationReasonSelected: false,
            loadingQueueSize: 0,
            lookupValues: [],
            cancellationReason: {}
        };
        _this.handleCancellationReasonDescription = _this.handleCancellationReasonDescription.bind(_this);
        _this.isCancellationReasonSelected = _this.isCancellationReasonSelected.bind(_this);
        _this.handleOnClickEvent = _this.handleOnClickEvent.bind(_this);
        return _this;
    }
    AutomaticRenewalCancellationReasonWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.incrementLoadingQueueSize(function () {
            _this.falconConvenienceApiService.getCustomerCancellationReasons(services_1.PRODUCT_WOLF_MOTOR)
                .pipe((0, operators_1.finalize)(function () { return _this.decrementLoadingQueueSize(); }))
                .subscribe(function (output) {
                _this.annualMotorCancellationReasons = output;
            });
        });
        this.incrementLoadingQueueSize(function () {
            _this.lookupService.fetchLookupValues("ClsInsurers", "en-UK")
                .pipe((0, operators_1.finalize)(function () { return _this.decrementLoadingQueueSize(); }))
                .subscribe(function (lookupValues) {
                _this.setState({
                    lookupValues: lookupValues.map(function (lookupValue) {
                        return { value: lookupValue.id, label: lookupValue.value };
                    })
                });
            });
        });
    };
    AutomaticRenewalCancellationReasonWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(components_1.Overlay, { show: this.state.loadingQueueSize > 0 }),
            this.renderAnnualMotorReasons()));
    };
    AutomaticRenewalCancellationReasonWidget.prototype.renderAnnualMotorReasons = function () {
        if (this.annualMotorCancellationReasons) {
            return (React.createElement("div", { className: "panel cancellation-reason-widget" },
                React.createElement("img", { className: "mr-2 car-cancellation-reason-icon", alt: "car-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-car-icon.png") }),
                React.createElement("div", { className: "pt-3 pb-2 font-weight-700 cancellation-reason-question" },
                    "Please tell us ",
                    React.createElement("span", { className: "font-weight-bold" }, "why you want to cancel your car policy renewal?")),
                React.createElement("div", { className: "d-block input-group margin-top-14 w-100", role: "group" }, this.renderAnnualCancellationReasons(this.annualMotorCancellationReasons))));
        }
    };
    AutomaticRenewalCancellationReasonWidget.prototype.renderAnnualCancellationReasons = function (reasons) {
        var _this = this;
        var reasonsRender = [];
        reasons.forEach(function (reason) {
            var _a;
            var hasReason = _this.state.cancellationReasonSelected && _this.state.cancellationReasonAnnualMotor === reason.cancellationReasonCode;
            reasonsRender.push(React.createElement(React.Fragment, null,
                React.createElement("div", { key: "motor-" + reason.cancellationReasonCode, className: "custom-control margin-bottom-20-padding-left-0" },
                    React.createElement("input", { className: "custom-radiobutton cursor-pointer", type: "radio", name: "".concat(reason.cancellationReasonCode, "_annualMotor"), id: "motor-option-".concat(reason.cancellationReasonCode, "_annualMotor"), value: reason.cancellationReasonCode, onChange: function (e) { return _this.handleCancellationReason(e); }, checked: reason.cancellationReasonCode === _this.state.cancellationReasonAnnualMotor }),
                    React.createElement("label", { id: "motor-option-".concat(reason.cancellationReasonCode, "-label"), className: "checkbox-label driver-label", htmlFor: "motor-option-".concat(reason.cancellationReasonCode) }, reason.cancellationReasonText)),
                (hasReason && (_this.state.cancellationReasonAnnualMotor === services_1.POOR_SERVICE_KEY || _this.state.cancellationReasonAnnualMotor === services_1.OTHER_KEY ||
                    _this.state.cancellationReasonAnnualMotor === services_1.ALLIANZ_CANT_INSURE_ME_KEY)) &&
                    React.createElement("div", { className: "form-group pb-2" },
                        React.createElement("label", { className: "font-light", htmlFor: "claimReasonDescription" }, "Please give us more details (optional)"),
                        React.createElement("textarea", { className: "form-control description-textarea", id: "cancellationReasonDescription", maxLength: 300, value: _this.state.cancellationReasonDescriptionAnnualMotor, onChange: function (e) { return _this.handleCancellationReasonDescription(e, reason.cancellationReasonCode, services_1.PRODUCT_WOLF_MOTOR); }, onClick: function (e) { return _this.handleCancellationReasonDescription(e, reason.cancellationReasonCode, services_1.PRODUCT_WOLF_MOTOR); } })),
                (hasReason && (_this.state.cancellationReasonAnnualMotor === services_1.SOLD_MY_CAR_KEY ||
                    _this.state.cancellationReasonAnnualMotor === services_1.CHANGED_MY_CAR_KEY)) &&
                    React.createElement("div", { className: "form-group pb-2" },
                        React.createElement("p", { className: "mb-0" }, "Did you know that you can replace your car without cancelling your policy."),
                        React.createElement("p", { className: "font-weight-bold" }, "Would you like a price to swap the insurance to a different car?"),
                        React.createElement("div", { className: "button-container" },
                            React.createElement("a", { className: "btn btn-blue mt-3 mb-0", href: "/journey/init/product/AnnualMotorInsurance/process/renewal/replaceCarEntryPage/".concat((_a = _this.props.interaction) === null || _a === void 0 ? void 0 : _a._id) }, "Yes, replace my car"),
                            React.createElement("button", { type: "button", className: "btn btn-white mt-3 mb-3", onClick: _this.handleOnClickEvent }, "No, cancel cover"))),
                (hasReason && _this.state.cancellationReasonAnnualMotor === services_1.TOO_EXPENSIVE_KEY) && _this.renderOtherInsurer()));
        });
        return reasonsRender;
    };
    AutomaticRenewalCancellationReasonWidget.prototype.renderOtherInsurer = function () {
        var _this = this;
        return (React.createElement("div", { className: "form-group changed-car-wrapper" },
            React.createElement("label", { className: "font-light", htmlFor: "betterPremiumInsurerId" }, "Please tell us who is giving you a better price"),
            React.createElement(react_select_1.default, { id: "betterPremiumInsurerId", className: "autocompleteNewInsurer ".concat(this.getSetting("cssClass", ""), " ").concat(this.getInputValidationClass()), classNamePrefix: "autocompleteNewInsurer", components: {
                    MenuList: ExtendedFalconDynamicOptimizedMenuList_1.default,
                    Option: FalconOptimizedOption_1.default,
                    DropdownIndicator: function () { return null; }
                }, options: this.state.lookupValues, name: "betterPremiumInsurerId", onChange: function (e) { return _this.handleBetterPremiumInsurerId(e); }, "aria-label": "Please tell us who is giving you a better price", placeholder: "Type new insurer name", filterOption: (0, react_select_1.createFilter)({ ignoreAccents: false, matchFrom: 'start' }), isClearable: true, openMenuOnClick: false, openMenuOnFocus: false }),
            React.createElement("label", { className: "font-light", htmlFor: "betterPremiumValue", style: { marginTop: 20 } }, "How much lower is the premium"),
            React.createElement("input", { className: "form-control description-textarea", id: "betterPremiumValue", type: "number", name: "betterPremiumValue", maxLength: 300, onChange: function (e) { return _this.handleBetterPremiumValue(e); }, min: 0 })));
    };
    AutomaticRenewalCancellationReasonWidget.prototype.handleBetterPremiumInsurerId = function (event) {
        var _a;
        var selectedInsurerId;
        if (!event) {
            selectedInsurerId = 0;
        }
        else {
            selectedInsurerId = event.value;
        }
        this.setState({ betterPremiumInsurerIdAnnualMotor: selectedInsurerId });
        var customerCancellationReason = (_a = this.state.cancellationReason) !== null && _a !== void 0 ? _a : {};
        customerCancellationReason.betterPremiumInsurerId = selectedInsurerId;
        this.setState({ cancellationReason: customerCancellationReason, cancellationReasonSelected: true });
        this.props.onStateChange("cancellationReasonInfo", customerCancellationReason);
    };
    ;
    AutomaticRenewalCancellationReasonWidget.prototype.getInputValidationClass = function () {
        var result = this.props.validations[this.props.question.name];
        if (!result) {
            return null;
        }
        if (result.valid) {
            if (this.getSetting("validFeedback")) {
                return "is-valid";
            }
        }
        else {
            return "is-invalid";
        }
        return null;
    };
    AutomaticRenewalCancellationReasonWidget.prototype.handleOnClickEvent = function () {
        this.executeEvent("click");
    };
    AutomaticRenewalCancellationReasonWidget.prototype.isCancellationReasonSelected = function () {
        return this.state.cancellationReasonSelected;
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], AutomaticRenewalCancellationReasonWidget.prototype, "falconConvenienceApiService", void 0);
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.LookupService),
        __metadata("design:type", Object)
    ], AutomaticRenewalCancellationReasonWidget.prototype, "lookupService", void 0);
    return AutomaticRenewalCancellationReasonWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AutomaticRenewalCancellationReasonWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AutomaticRenewalCancellationReasonWidget.js
// module id = 3235
// module chunks = 0